import React from 'react';

class MainButton extends React.Component {
  render() {
    return (
      <a href="#" className="Button" data-primary={this.props.primary}>{this.props.text}</a>
    );
  }
}

export default MainButton;